// extracted by mini-css-extract-plugin
export default {"root":"OlympDataCardTitle_root__AQJhG"};